(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MapboxFPS", [], factory);
	else if(typeof exports === 'object')
		exports["MapboxFPS"] = factory();
	else
		root["MapboxFPS"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition